// extracted by mini-css-extract-plugin
module.exports = {"container":"_slug__container__5mR_x","content":"_slug__content__frWjt","image":"_slug__image__hs6A_"};